<div [formGroup]="formGroup">
    <dff-form-control [formControl]="asDffFormControl(formGroup.group('vaerdi').control('aktuel'))"></dff-form-control>
</div>
